import { get, patch, post } from '../client/client';
import { endpoint } from '../endpoint';
import type { PageQuery } from '../type/payment';
import type { MemberTransactionListResponse } from '../type/transaction';
import type { UserCreate, UserListResponse, UserPublic, UserUpdate } from '../type/user';

export const getUsers = async (params: PageQuery) => {
  return await get<UserListResponse>(endpoint.getUsers, { params });
};

/** Every policy, loan and balance transaction of one member, newest first. */
export const getMemberTransactions = async (userId: number) => {
  return await get<MemberTransactionListResponse>(endpoint.getMemberTransactions(userId));
};

export const getUser = async (userId: number) => {
  return await get<UserPublic>(endpoint.getUser(userId));
};

export const createUser = async (payload: UserCreate) => {
  return await post<UserPublic, UserCreate>(endpoint.createUser, payload);
};

export const updateUser = async (userId: number, payload: UserUpdate) => {
  return await patch<UserPublic, UserUpdate>(endpoint.updateUser(userId), payload);
};
